<script lang="ts">
    import { isActive, url } from "@roxi/routify";
    import type { Link } from "./Nav.svelte";
    import { clickOutside } from "../helpers/clickOutside";
    import { fade } from "svelte/transition";
    import { onDestroy, onMount } from "svelte";
    export let links: Link[];
    export let base: string;

    export let open: boolean = false;
    export let isMobile: boolean = false;

    const closeDropdown = () => {
        open = false;
    };

    //* routify is blocked when on:click|stopPropagation is used, fix:
    onMount(() => {
        setTimeout(() => {
            document.addEventListener("click", closeDropdown);
        }, 0);
    });
    onDestroy(() => document.removeEventListener("click", closeDropdown));
</script>

<div class="nav-dropdown" transition:fade={{ duration: 250 }}>
    {#each links as [path, name, submenu]}
        <a class="nav-link" href={$url(base + path)} class:active={$isActive(base + path)}>
            <div class="inner">
                {#if $isActive(base + path) && isMobile == false}
                    <div class="active-blinker" />
                {/if}
                {name}
            </div>
        </a>
    {/each}
</div>

<style lang="scss">
    @import "./src/vars";

    .nav-dropdown {
        position: absolute;
        bottom: 0;
        left: 0%;
        // left: 50%;
        transform: translate(-0%, 100%);
        // transform: translate(-50%, 100%);
        display: none;
        padding: 1rem;
        background-color: rgba($grayDark2, 0.9);
        display: flex;
        flex-direction: column;
        min-width: 14rem;
        .nav-link {
            position: relative;
            font-weight: 300;
            color: $yellow;
            width: 100%;
            line-height: 1.4 !important;
            padding: 0.8em 0em;
            border-bottom: 1px solid $yellow;
            @media (max-width: 900px) {
                padding: 0.4em 0em;
                text-align: center;
                color: $grayLight;
                border-bottom-color: $grayLight;
                border: none;
            }
            &:first-child {
                padding-top: 0;
            }
            &:last-child {
                border-bottom: none;
                padding-bottom: 0;
            }

            .inner {
                position: relative;
            }

            .active-blinker {
                position: absolute;
                top: 0.6em;
                left: -0.7em;
                border-radius: 1000px;
                height: 0.4em;
                width: 0.4em;
                animation: 1s blinking infinite forwards;
            }
        }

        @media (max-width: 900px) {
            position: relative;
            top: unset;
            bottom: unset;
            left: unset;
            transform: unset;
            display: flex;
            // border: 1px solid $yellow;
            border-top: none;
            border-color: $grayLight;
            border-bottom-color: transparent;
            background-color: transparent;
        }
    }
</style>
